import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import './Follow.css'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const achorTagStyle = {
  color: 'rgba(0, 0, 0, 0.54)',
};

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function Follow() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <div
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={handleClick}
        className="follow"
      >
        Follow
      </div>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <a
          href="https://www.instagram.com/brucemelodie/"
          target="_blank"
          rel="noreferrer"
          style={achorTagStyle}
        >
          <StyledMenuItem>
            <ListItemIcon>
              <InstagramIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Instagram" />
          </StyledMenuItem>
        </a>
        <a
          href="https://www.facebook.com/brucemelodierw"
          target="_blank"
          rel="noreferrer"
          style={achorTagStyle}
        >
          <StyledMenuItem>
            <ListItemIcon>
              <FacebookIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText primary="Facebook" />
          </StyledMenuItem>
        </a>
        <a
          href="https://twitter.com/BruceMelodie"
          target="_blank"
          rel="noreferrer"
          style={achorTagStyle}
        >
          <StyledMenuItem>
            <ListItemIcon>
              <TwitterIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText primary="Twitter" />
          </StyledMenuItem>
        </a>
        <a
          href="https://www.youtube.com/channel/UCbp-tIRMJP4SwLjYlJCrolA"
          target="_blank"
          rel="noreferrer"
          style={achorTagStyle}
        >
          <StyledMenuItem>
            <ListItemIcon>
              <YouTubeIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText primary="Youtube" />
          </StyledMenuItem>
        </a>
      </StyledMenu>
    </div>
  );
}
